/**
 * Query keys for organization-related queries
 * Following controller method naming convention
 */
export const organizationKeys = {
  getCurrentOrganization: () =>
    ["organization", "getCurrentOrganization"] as const,
  getProfile: (uuid: string) => ["organization", "getProfile", uuid] as const,
  // Profile operations
  updateProfile: () => ["organization", "updateProfile"] as const,
  publishProfile: () => ["organization", "publishProfile"] as const,
  unpublishProfile: () => ["organization", "unpublishProfile"] as const,
  generatePreviewToken: () => ["organization", "generatePreviewToken"] as const,
  // Logo operations
  uploadLogo: () => ["organization", "uploadLogo"] as const,
  deleteLogo: () => ["organization", "deleteLogo"] as const,
} as const
